exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lomBold{font-weight:500}.decision label.el-form-item__label{color:red!important;font-weight:700;font-size:1.575rem}", ""]);

// exports
